import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import SimpleHeader from "../components/SimpleHeader";
import friendDatabase from "../database/friends.json";
import Friend from "../components/Friend";
import PageTitle from "../components/PageTitle";

const Friendbook = () => {
    return (
        <>
            <PageTitle title='Friendbook' />
            <Header />
            <div className='main-container'>
                <SimpleHeader
                    title={"friendbook"}
                    route={"friendbook"}
                    url={"friendbook"}
                />
                <div className='friendbook-container flex col gap-sm'>
                    {friendDatabase.map((friend, index) => (
                        <Friend
                            key={index}
                            name={friend.name}
                            content={friend.content}
                            image={friend.image}
                        />
                    ))}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Friendbook;